// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disCHeck {
    display: inline-block;
}
.disclousureText {
    display: inline-block;
    padding-left: 10px;
    width: 95%;
    vertical-align: top;
}
.paddL1 {
    padding-left: 10px;
}
.lblWrist {
    display: inline-block;
    vertical-align: bottom;
}
.alert.alert-danger {
    padding: 3px 10px 0 0;
    font-size: 14px;
    line-height: normal;
    background: none;
    border: none;
    color: #a94442;
    text-align: left;
    width: 100%;
    display: inline-block;
    margin: 0;
}
.publishSec {
    padding-top: 28px;
    text-align: center;
}
.publishSec .lblWrist {
    vertical-align: baseline;
}
.gender .custom-control-label::before, .gender .custom-control-label::after {
    top: .15rem;
}
.alertText {
    font-size: 80%;
    color: #dc3545;
}
.col-md-2.gender {
    flex: auto;
    max-width: 150px;
}
.studyDetform .userDetail {
    max-width: 230px;
}
.example-chip-list {
  width: 100%;
}
.mat-form-field-wrapper {
  padding: 0;
}
input::placeholder {
  color: #a9a9a9;
}

.previewBtn {
  border: 1px solid #d9d9d9 !important;
  height: 30px;
  background-color: #fff;
  margin-left: 15px;
  font-weight: 600;
}

.previewBtn:hover {
  color: #FFFFFF;
  border: 1px solid #0094ff;
  background-color: #0094ff;
}

.dropdownWrap {
  position: absolute;
  top: -85px;
  right: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.dropdownWrap .lbl {
  margin-bottom: 5px;
}

.statusDropdown {
  width: 220px!important;
}

.statuslbl {
  margin-right: 140px;
}

.custom-margin-left {
  margin-left:42px;
}

.ck-editor__editable {
  padding-right: 30px !important;
}

.reqCard .ck-editor__editable {
  min-height: 140px !important;
}

.screeningScheduleAlign{
  margin-right: 0%;
}

.screeningScheduleChk{
    top: 0px !important;
    margin-left: -20px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/Study/admin_study_detail/admin_study_detail.component.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,SAAS;AACb;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,cAAc;AAClB;AACA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AAOA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;AACjC","sourcesContent":[".disCHeck {\r\n    display: inline-block;\r\n}\r\n.disclousureText {\r\n    display: inline-block;\r\n    padding-left: 10px;\r\n    width: 95%;\r\n    vertical-align: top;\r\n}\r\n.paddL1 {\r\n    padding-left: 10px;\r\n}\r\n.lblWrist {\r\n    display: inline-block;\r\n    vertical-align: bottom;\r\n}\r\n.alert.alert-danger {\r\n    padding: 3px 10px 0 0;\r\n    font-size: 14px;\r\n    line-height: normal;\r\n    background: none;\r\n    border: none;\r\n    color: #a94442;\r\n    text-align: left;\r\n    width: 100%;\r\n    display: inline-block;\r\n    margin: 0;\r\n}\r\n.publishSec {\r\n    padding-top: 28px;\r\n    text-align: center;\r\n}\r\n.publishSec .lblWrist {\r\n    vertical-align: baseline;\r\n}\r\n.gender .custom-control-label::before, .gender .custom-control-label::after {\r\n    top: .15rem;\r\n}\r\n.alertText {\r\n    font-size: 80%;\r\n    color: #dc3545;\r\n}\r\n.col-md-2.gender {\r\n    flex: auto;\r\n    max-width: 150px;\r\n}\r\n.studyDetform .userDetail {\r\n    max-width: 230px;\r\n}\r\n.example-chip-list {\r\n  width: 100%;\r\n}\r\n.mat-form-field-wrapper {\r\n  padding: 0;\r\n}\r\ninput::-webkit-input-placeholder { /* Edge */\r\n  color: #a9a9a9;\r\n}\r\ninput:-ms-input-placeholder { /* Internet Explorer 10-11 */\r\n  color: #a9a9a9;\r\n}\r\ninput::placeholder {\r\n  color: #a9a9a9;\r\n}\r\n\r\n.previewBtn {\r\n  border: 1px solid #d9d9d9 !important;\r\n  height: 30px;\r\n  background-color: #fff;\r\n  margin-left: 15px;\r\n  font-weight: 600;\r\n}\r\n\r\n.previewBtn:hover {\r\n  color: #FFFFFF;\r\n  border: 1px solid #0094ff;\r\n  background-color: #0094ff;\r\n}\r\n\r\n.dropdownWrap {\r\n  position: absolute;\r\n  top: -85px;\r\n  right: 0;\r\n  z-index: 3;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n}\r\n\r\n.dropdownWrap .lbl {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.statusDropdown {\r\n  width: 220px!important;\r\n}\r\n\r\n.statuslbl {\r\n  margin-right: 140px;\r\n}\r\n\r\n.custom-margin-left {\r\n  margin-left:42px;\r\n}\r\n\r\n.ck-editor__editable {\r\n  padding-right: 30px !important;\r\n}\r\n\r\n.reqCard .ck-editor__editable {\r\n  min-height: 140px !important;\r\n}\r\n\r\n.screeningScheduleAlign{\r\n  margin-right: 0%;\r\n}\r\n\r\n.screeningScheduleChk{\r\n    top: 0px !important;\r\n    margin-left: -20px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
